import { FeedbackCategory } from "models/enumerations/messages/feedback-category";
import { FeedbackRating } from "models/enumerations/messages/feedback-rating";
import ConversationMessageFeedbackRecord from "models/view-models/conversations/conversation-message-feedback-record";
import ServiceFactory from "utilities/services/service-factory";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

export interface MessageFeedbackBasePathParams {
    conversationId: string;
    messageId: string;
}

export interface UpdateMessageFeedbackPathParams
    extends MessageFeedbackBasePathParams {
    feedbackId: string;
}

export interface UpdateMessagePatchParams {
    rating?: FeedbackRating;
    feedbackCategory?: FeedbackCategory;
    feedbackComment?: string;
}

// #endregion Interfaces
// -------------------------------------------------------------------------------------------------

// -------------------------------------------------------------------------------------------------
// #region Constants
// -------------------------------------------------------------------------------------------------

const baseEndpoint =
    "conversations/:conversationId/messages/:messageId/feedback";
const updateMessageFeedbackEndpoint = `${baseEndpoint}/:feedbackId`;
const resourceType = ConversationMessageFeedbackRecord;

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Service
// -------------------------------------------------------------------------------------------------

const MessageFeedbackService = {
    createFeedbackRating: ServiceFactory.nestedCreate<
        ConversationMessageFeedbackRecord,
        MessageFeedbackBasePathParams
    >(resourceType, baseEndpoint),

    updateFeedbackRating: ServiceFactory.patch<
        ConversationMessageFeedbackRecord,
        UpdateMessageFeedbackPathParams,
        UpdateMessagePatchParams
    >(resourceType, updateMessageFeedbackEndpoint),
};

// #endregion Service

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export default MessageFeedbackService;

// #endregion Exports
